/* eslint-disable @typescript-eslint/no-explicit-any */
import React, {ReactNode, useEffect, useState} from 'react';
import {IconButton, Tooltip, Typography, Stack} from '@mui/material';
import {
  Delete as DeleteIcon,
  FilterList as FilterListIcon,
} from '@mui/icons-material';
import Button from '../../../components/Button/Button';
import {formatDateTime} from '../../../utils';

// style
import {
  Spacer,
  StyledHeader,
  StyledToolbar,
  StyleItemFilter,
} from './EnhancedTableToolbar.style';

export type ListFilterProps = {
  label?: string;
  key?: string | number;
};

export type ParamsProps = {
  _page?: number;
  _size?: number;
  status_eq?: number;
};

type EnhancedTableToolbarProps = {
  numSelected?: number;
  isHeader?: boolean;
  isFilter?: boolean;
  childrenHeader?: ReactNode;
  isAddNew?: boolean;
  onOpenFilter?: () => void;
  onClickAddNew?: () => void;
  setTypeFilter?: (any) => void;
  titleHeader?: string;
  isLoading?: boolean;
  setParams?: (ParamsProps) => void;
  canCreate?: boolean;
  isDisabledAddNew?: boolean;
  enableDeletedTab?: boolean;
};

function EnhancedTableToolbar({
  numSelected,
  onOpenFilter,
  isHeader,
  titleHeader = '',
  isFilter = false,
  isAddNew = false,
  childrenHeader,
  onClickAddNew,
  isLoading,
  setParams,
  canCreate,
  isDisabledAddNew = false,
  enableDeletedTab = false,
}: EnhancedTableToolbarProps) {
  const getCurrentDate = new Date().toISOString();

  const [listFilter, setListFilter] = useState<ListFilterProps[]>([
    {
      label: 'Active',
      key: 'Active',
    },
    {
      label: 'Scheduled',
      key: 'Scheduled',
    },
    {
      label: 'Expired',
      key: 'Expired',
    },
    {
      label: 'Unpublished',
      key: 'Unpublished',
    },
  ]);

  const [activeFilter, setActiveFilter] = useState<ListFilterProps>({
    label: 'Active',
    key: 'Active',
  });

  const onClickFilter = value => {
    if (value) {
      const findData = listFilter.find(item => item.key === value);
      setActiveFilter(findData);
      switch (findData.key) {
        case 'Active':
          return setParams(preState => ({
            ...preState,
            _page: 0,
            _size: 99999,
            endDateTime_gte: undefined,
            endDateTime_gt: getCurrentDate,
            startDateTime_lte: getCurrentDate,
            isPublished_eq: true,
            endDateTime_lte: undefined,
            startDateTime_gte: undefined,
            endDateTime_lt: undefined,
            startDateTime_gt: undefined,
            _sort: 'displayOrder:asc',
          }));
        case 'Scheduled':
          return setParams(preState => ({
            ...preState,
            _page: 0,
            _size: 10,
            isPublished_eq: true,
            _sort: 'startDateTime:asc',
            startDateTime_gt: getCurrentDate,
            startDateTime_gte: undefined,
            startDateTime_lte: undefined,
            endDateTime_gte: undefined,
            endDateTime_lte: undefined,
            endDateTime_lt: undefined,
            endDateTime_gt: undefined,
          }));
        case 'Expired':
          return setParams(preState => ({
            ...preState,
            _page: 0,
            _size: 10,
            _sort: 'endDateTime:desc',
            startDateTime_gte: undefined,
            startDateTime_gt: undefined,
            startDateTime_lte: undefined,
            endDateTime_gte: undefined,
            endDateTime_lte: getCurrentDate,
            endDateTime_lt: undefined,
            endDateTime_gt: undefined,
            isPublished_eq: true,
          }));
        case 'Unpublished':
          return setParams(preState => ({
            ...preState,
            _page: 0,
            _size: 10,
            _sort: 'updatedDateTime:desc',
            startDateTime_gte: undefined,
            startDateTime_gt: undefined,
            startDateTime_lte: undefined,
            endDateTime_gte: undefined,
            endDateTime_lt: undefined,
            endDateTime_gt: undefined,
            endDateTime_lte: undefined,
            isPublished_eq: false,
          }));
        default:
          setParams(preState => ({
            ...preState,
            _page: 0,
            _size: 99999,
            startDateTime_gt: undefined,
            startDateTime_lte: getCurrentDate,
            startDateTime_gte: undefined,
            isPublished_eq: true,
            endDateTime_lt: undefined,
            endDateTime_gt: undefined,
            endDateTime_lte: undefined,
            endDateTime_gte: getCurrentDate,
            _sort: 'displayOrder:asc',
            isUnpublished_eq: undefined,
          }));
      }
    }
    return null;
  };

  return (
    <StyledHeader>
      {isHeader && (
        <StyledToolbar>
          {isAddNew && !titleHeader && (
            <Stack direction="row" spacing={3} mt={4} mb={4}>
              {listFilter.map((item, key) => (
                <StyleItemFilter
                  key={key}
                  className={`${
                    activeFilter.key === item.key ? 'active' : 'inactive'
                  }`}
                  onClick={() => {
                    onClickFilter(item.key);
                  }}
                >
                  {item.label}
                </StyleItemFilter>
              ))}
            </Stack>
          )}
          <Spacer />
          {isFilter && (
            <div>
              {numSelected > 0 ? (
                <Tooltip title="Delete">
                  <IconButton aria-label="Delete" size="large">
                    <DeleteIcon />
                  </IconButton>
                </Tooltip>
              ) : (
                <Tooltip title="Filter list">
                  <IconButton
                    aria-label="Filter list"
                    size="large"
                    onClick={onOpenFilter}
                  >
                    <FilterListIcon />
                  </IconButton>
                </Tooltip>
              )}
            </div>
          )}
          {isAddNew && (
            <div
              style={{
                width: '100%',
                textAlign: 'right',
              }}
            >
              {!!canCreate && (
                <Button
                  onClick={onClickAddNew}
                  type="button"
                  loading={isLoading}
                  disabled={isDisabledAddNew}
                >
                  Add new
                </Button>
              )}
            </div>
          )}
        </StyledToolbar>
      )}
    </StyledHeader>
  );
}
export default EnhancedTableToolbar;
